import Vue from 'vue'
import Router from 'vue-router'
import PersonalCenter from '@/views/PersonalCenter'
import store from '../store'
import {checkCode} from '../api/index'
import wxConfig from '../utils/config'
import weixinClosePage from '../utils/wxClosePage'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'PersonalCenter',
      component: PersonalCenter,
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/records',
      name: 'DonationRecords',
      component: () => import('../views/DonationRecords.vue'),
      meta: {
        title: '捐款记录'
      }
    },
    {
      path: '/vip',
      name: 'VIP',
      component: () => import('../views/Vip.vue'),
      meta: {
        title: '会员续费'
      }
    },
    {
      path: '/edit',
      name: 'EditInf',
      component: () => import('../views/EditInf.vue'),
      meta: {
        title: '完善个人信息'
      }
    },
    {
      path: '/changeMobile',
      name: 'ChangeMobile',
      component: () => import('../views/ChangeMobile.vue'),
      meta: {
        title: '更换登录手机'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue'),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/contribute',
      name: 'contribute',
      component: () => import('../views/Contribute.vue'),
      meta: {
        title: '我要捐款'
      }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  if (store.token || to.path === '/login' || sessionStorage.getItem('token')) return next()
  function getQueryString (name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    let res = window.location.search.substr(1).match(reg)
    if (res != null) {
      return decodeURIComponent(res[2])
    }
    location.replace(wxConfig.orginUrl)
    return null
  }
  let code = getQueryString('code')
  const { data: res } = await checkCode(code)
  if (res) {
    if (res.code === 200) {
      store.openId = res.data.openId
      if (res.data.hasRegister === true) {
        store.token = res.data.token
        sessionStorage.setItem('token', res.data.token)
        return next()
      }
      router.replace({path: '/login', query: {url: to.path}})
      // next('/login')
      return
    } else {
      switch (to.path) {
        case '/vip':
          location.replace(wxConfig.wxMenuUrl.vip)
          break
        case '/contribute':
          location.replace(wxConfig.wxMenuUrl.contribute)
          break

        default:
          location.replace(wxConfig.orginUrl)
          break
      }
      // location.replace(wxConfig.orginUrl)
      // alert(res.message + to.path + ', 请从公众号菜单栏处打开, 关闭页面')
      // weixinClosePage()
      return
      // alert(res.message || '数据获取失败~')
      // console.log(res.message)
      // this.$vux.toast.show({
      //   text: res.message || '数据获取失败~',
      //   type: 'cancel'
      // })
    }
  }
  alert('系统错误，关闭页面')
  weixinClosePage()
  // next('/login')
  // next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js